import type { ModelProvider } from './model';

export {
  AnthropicProvider,
  type AnthropicProviderOptions,
} from './providers/anthropic';
export {
  DashScopeProvider,
  type DashScopeProviderOptions,
} from './providers/dashscope';
export {
  DeepSeekProvider,
  type DeepSeekProviderOptions,
} from './providers/deepseek';
export { HepAIProvider, type HepAIProviderOptions } from './providers/hepai';
export { KimiProvider, type KimiProviderOptions } from './providers/kimi';
export {
  MiniMaxProvider,
  type MiniMaxProviderOptions,
} from './providers/minimax';
export {
  OpenAIChatCompletionsProvider,
  type OpenAIChatCompletionsProviderOptions,
} from './providers/openai/chat-completions-provider';
export {
  OpenAIProvider,
  type OpenAIProviderOptions,
} from './providers/openai/openai-provider';

let DEFAULT_PROVIDER: ModelProvider | undefined;

export function setDefaultModelProvider(provider: ModelProvider) {
  DEFAULT_PROVIDER = provider;
}

export function getDefaultModelProvider(): ModelProvider {
  if (typeof DEFAULT_PROVIDER === 'undefined') {
    throw new Error(
      'No default model provider set. Make sure to set a provider using setDefaultModelProvider before calling getDefaultModelProvider or pass an explicit provider.',
    );
  }
  return DEFAULT_PROVIDER;
}
